import { Card } from "antd";
import styled from "styled-components";
import Colors from "../../themes/Colors";

export const SelectionCardItemHolder = styled(Card)`
    cursor: pointer;
    width: 100%;
    border-color: ${props => props.checked && Colors.primary};
    border-radius: 4px;

    .ant-card-body {
        padding: 16px;
    }
`;